import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"

export const obterCompartimentoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Compartimento/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterCompartimentoPorPlanoAsync = async (idPlano) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Compartimento/obterListaPorPlano/` + idPlano, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarCompartimentoAsync = async (descricao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao: normalizeTextUppercase(descricao) })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Compartimento`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarCompartimentoAsync = async (id, descricao, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao: normalizeTextUppercase(descricao), ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Compartimento/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
